export type ProdantixErrorCode = 'config' | 'queue_overflow' | 'transport' | 'validation';

export class ProdantixError extends Error {
  readonly code: ProdantixErrorCode;

  constructor(code: ProdantixErrorCode, message: string, options?: ErrorOptions) {
    super(message, options);
    this.code = code;
    this.name = 'ProdantixError';
  }
}

export class ConfigError extends ProdantixError {
  constructor(message: string) {
    super('config', message);
    this.name = 'ConfigError';
  }
}

export class ValidationError extends ProdantixError {
  readonly field: string;

  constructor(field: string, message: string) {
    super('validation', message);
    this.field = field;
    this.name = 'ValidationError';
  }
}

export class TransportError extends ProdantixError {
  readonly status?: number;

  constructor(message: string, status?: number, options?: ErrorOptions) {
    super('transport', message, options);
    this.status = status;
    this.name = 'TransportError';
  }
}
